<template>
  <CalicoOnboarding
    :loading="loading"
    :form-data="formData"
    @save="save"
  >
    <div class="personal-details">
      <CalicoFormHeader />
      <CalicoForm
        name="first_name"
        label="First Name"
        class="body--medium"
      >
        {{ formData.first_name }}
      </CalicoForm>
      <CalicoForm
        name="last_name"
        label="Last Name"
        class="body--medium"
      >
        {{ formData.last_name }}
      </CalicoForm>
      <CalicoForm
        v-slot="{ field, error }"
        label="Date of Birth"
        name="date_of_birth"
        rules="required"
      >
        <CalicoField 
          v-model="formData.date_of_birth" 
          v-bind="field" 
          type="date" 
          :error="error"
          :max="maxDateOfBirth" 
          icon="calendar3" 
        />
      </CalicoForm>
    </div>
  </CalicoOnboarding>
</template>

<script>
import CalicoFormHeader from "@/components/calico/formHeader/index.vue"
import CalicoOnboarding from "@/components/template/onboarding/index.vue";
import CalicoField from '@/components/calico/field/index.vue';
import CalicoForm from "@/components/pattern/form/index.vue";
import services from "@/services";
export default {
  name: 'PersonalDetailsScreen',
  components: {
    CalicoFormHeader,
    CalicoOnboarding,
    CalicoField,
    CalicoForm,
  },
  data() {
    return {
      formData: {
        first_name: "",
        last_name: "",
        date_of_birth: ""
      },
      loading: true,
    };
  },
  computed: {
    maxDateOfBirth() {
      const d = new Date()
      d.setFullYear(d.getFullYear() - 18)
      return d.toISOString().split('T')[0]
    }
  },
  async mounted() {
    const formData = await services.user.details.get();
    this.formData = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      date_of_birth: formData.date_of_birth
    }
    this.loading = false
  },
  methods: {
    async save(next) {
      this.loading = true
      await services.user.details.post(this.formData);
      next()
      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.personal-details {
  @include stack-space($space-large);
  padding: $space-large;
}
</style>